// biome-ignore lint/suspicious/noExplicitAny: we need to use any
export function hasGenderId(obj: any): obj is { genderId: number } {
    return obj && typeof obj.genderId === 'number';
}
